import Month from "react-big-calendar/lib/Month";
export default Month;
